import styled from 'styled-components'

/*
 * <LoginErrorMessage />
 */
export default styled.p`
  color: #d0021b !important;
  text-align: center !important;
  margin: 10px 0;
  min-height: 24px;
`
